var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVecot648(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 38,
    viewBox: "0 0 44 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 648",
    d: "M2 36.5V23.2424M7.92593 36.5V20.0606M13.4815 36.5V27.4848M18.6667 36.5V13.1667M24.5926 36.5V9.45455M30.1481 36.5V15.2879M36.0741 36.5V10.5152M42 36.5V1.5",
    stroke: "#FDB62F",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVecot648);
export default __webpack_public_path__ + "static/media/vecot648.fe75394587ff1462b0d03a302a0793e9.svg";
export { ForwardRef as ReactComponent };